<template>
  <div class="tag">
    <el-button size="mini" type="primary" @click="typeAdd" icon="el-icon-plus">添加新标签</el-button>

    <div class="table-style">
      <el-form class="form-style" :inline="true" size="small">
        <el-form-item label="标签名称:">
          <el-input v-model="title" clearable placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-button size="mini" type="primary" @click="searc">查询</el-button>
      </el-form>
      <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" prop="sort_num" label="排序号" width="100"></el-table-column>
        <el-table-column align="center" prop="name" label="标签名称"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="updateTag(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="deleteTag(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-style">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page_no"
        layout="total, prev, pager, next"
        :total="total"
        :page-size="20"
      ></el-pagination>
    </div>-->

    <el-dialog title="新增标签" :visible.sync="dialogVisible">
      <el-form
        class="form-style"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
        label-position="left"
      >
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number v-model="form.sort_num" :precision="2" :step="0.01"></el-input-number>
        </el-form-item>

        <el-form-item label="标签名称" required prop="name">
          <el-input placeholder="请输入标签名称" v-model="form.name" style="width: 400px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog('form')">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listType, typeAdd, typeDel } from "@/api/operationalActivities.js";

export default {
  name: "tag",
  data() {
    return {
      //   total: 0,
      //   page_no: 1,
      tagId: "",
      title: "",
      form: {
        name: "",
        sort_num: 0
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入标题",
            trigger: "change"
          },
          {
            required: true,
            message: "请输入标题",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.listType();
  },
  methods: {
    searc() {
      this.listType();
    },
    //获取列表
    listType() {
      listType({
        name: this.title
      }).then(res => {
        this.tableData = res.runTrainingTypeList;
        this.total = res.total;
      });
    },

    // handleCurrentChange(val) {
    //   this.page_no = val;
    //   this.listType();
    // },

    typeAdd() {
      this.dialogVisible = true;
      this.tagId = "";
      this.form.sort_num = 0;
      this.form.name = "";
      this.listType();
    },
    //新增
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.tagId === "") {
            typeAdd({
              name: this.form.name,
              sort_num: this.form.sort_num
            }).then(() => {
              //   this.$message.success("修改标签成功！");
              this.dialogVisible = false;
              this.listType();
            });
          } else {
            console.log("新增标签");
            console.log(this.form);
            typeAdd({
              name: this.form.name,
              run_training_type_id: this.tagId,
              sort_num: this.form.sort_num
            }).then(() => {
              //   this.$message.success("添加标签成功！");
              this.dialogVisible = false;
              this.listType();
            });
          }
        }
      });
    },
    quitDialog(formName) {
      this.tagId = "";
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    updateTag(row) {
      this.tagId = row.id;
      this.form.name = row.name;
      this.form.sort_num = row.sort_num;
      this.dialogVisible = true;
    },

    deleteTag(row) {
      typeDel({
        run_training_type_id: row.id
      }).then(() => {
        this.$message.success("删除成功！");
        this.listType();
      });
    }
  }
};
</script>

<style scoped lang="scss">
.tag {
  height: 100%;
  background-color: #fff;
  padding: 15px;
  margin: 10px;
  border-radius: 5px;
  .form-style {
    margin-left: 15px;
  }
  .table-style {
    margin-top: 20px;
  }
}
</style>
